//import { combineReducers } from 'redux'
import authReducers from "./auth/redux_reducers";
import channelState from "./application/channelDashboard/redux_reducers";
import storeState from "./application/store/redux_reducers";
import userState from "./application/user/redux_reducers"
let reducers = { auth: authReducers, channelState, storeState, userState };

//export default combineReducers(reducers)
export default reducers;